module.exports = __webpack_public_path__ + "img/rightSider.c6a8e67b.png";